import styled from "styled-components";
import { media } from "@/theme/breakpoints";

export const PageRoot = styled.div`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  background: #fafafa;
  overflow-x: hidden;
  box-sizing: border-box;

  ${media.downMobile`
    padding: 16px;
  `}
`;

export const Card = styled.div`
  width: 100%;
  max-width: 620px;
  background: #fff;
  border: 1px solid #dae0e7;
  border-radius: 10px;
  padding: 40px 24px;
  box-sizing: border-box;

  ${media.downMobile`
    padding: 32px 16px;
  `}
`;
